module.exports = __webpack_public_path__ + "c3878034cfe65c80434a12f7e96bf144.jpg";